<osp-dialog>
  <ng-template ospTemplate="content">
    <div class="pb-6">
      {{ 'shared.createEntity.entitySelection.title' | translate }}
    </div>
    <osp-card-option-list class="pb-6" [options]="assets" [(ngModel)]="$selectedType" />
  </ng-template>
</osp-dialog>
